import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import DraftListingContext from './DraftListing.context';
import api from 'api';
import { Listing } from 'models/Listing';
import AuthContext from 'providers/Auth/Auth.context';
import mixpanelService from 'services/mixpanelService';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import { getMixpanelErrorProps } from 'axiosUtils';
import { ErrorViewedProps } from 'models/MixpanelEvents';

const DraftListing: React.FC = (props) => {
  const { children } = props;

  const [draftListing, setDraftListing] = useState<Listing>(null);

  const { isLoggedIn } = useContext(AuthContext);

  const getMixpanelProps = useGetMixpanelProps();

  const hasDraftBanner = useMemo(() => !!draftListing, [draftListing]);

  const removeDraftListing = useCallback(() => setDraftListing(null), []);

  useEffect(() => {
    if (!isLoggedIn) return;

    (async () => {
      try {
        const { data } = await api.portfolio.seller.getDraftListing();
        setDraftListing(data);
      } catch (e) {
        mixpanelService.errorViewed(
          getMixpanelProps(getMixpanelErrorProps(e)) as ErrorViewedProps,
        );
      }
    })();
  }, [getMixpanelProps, isLoggedIn]);

  return (
    <DraftListingContext.Provider
      value={{ draftListing, hasDraftBanner, removeDraftListing }}
    >
      {children}
    </DraftListingContext.Provider>
  );
};

export default DraftListing;
